module.exports = __webpack_public_path__ + "static/media/company-bg.37ce6ab5.jpg";